import React from "react";
import { useAccordionItem, useAccordionItemEffect, useHeightTransition } from "@szhsin/react-accordion";
import ChevronDown from "@site/static/img/chevron-down.svg";
import styles from "./accordion.module.scss";
import { BiChevronDown } from "react-icons/bi";
import GradientCursorFollower from "@/components/layout/gradient-cursor-follow/gradient-cursor-follower";

const AccordionItem = ({
  header,
  children,
  itemKey,
  initialEntered,
  disabled,
}: {
  header: React.ReactNode;
  children: React.ReactNode;
  itemKey?: string | number;
  initialEntered?: boolean;
  disabled?: boolean;
}) => {
  const { itemRef, state, toggle } = useAccordionItemEffect<HTMLDivElement>({
    itemKey,
    initialEntered,
    disabled,
  });
  const { buttonProps, panelProps } = useAccordionItem({
    state,
    toggle,
    disabled,
  });

  const [transitionStyle, panelRef] = useHeightTransition<HTMLDivElement>(state);

  const { status, isMounted, isEnter } = state;

  return (
    <div className={styles.item} ref={itemRef as React.LegacyRef<HTMLDivElement>}>
      <h3 style={{ margin: 0 }}>
        <button className={isEnter ? styles.buttonExpanded : styles.button} type="button" {...buttonProps}>
          <GradientCursorFollower />
          {header}
          <BiChevronDown className={styles.chevron} size={30} />
        </button>
      </h3>
      {isMounted && (
        // Add an extra `div` around the panel `div` for the
        // height transition to work as intended
        <div
          className={styles.content}
          style={{
            display: status === "exited" ? "none" : undefined,
            ...transitionStyle,
          }}>
          <div className={styles.panel} ref={panelRef as React.LegacyRef<HTMLDivElement>} {...panelProps}>
            {children}
          </div>
          {/* Closing tag of the extra `div` */}
        </div>
      )}
    </div>
  );
};

export default AccordionItem;
